import { Box } from '@mui/material'
import { storageNestedTabs } from '../utils/consts'
import NestedTabsPage from '../layouts/NestedTabsPage'
import { Entity } from 'utils/hooks/usePermissions'
import { Navigate } from 'react-router-dom'
import { NoPermission } from 'pages/NoPermission/NoPermission'
import { useDataPermissions } from '../hooks/useDataPermissions'

const StorageData = () => {
  const { hasPermission, redirectPath, showNoPermission } = useDataPermissions(
    Entity.WHEAT_CODE,
    'SHOW_WHEAT'
  )

  if (!hasPermission) {
    if (redirectPath) {
      return <Navigate to={redirectPath} replace />
    }
    if (showNoPermission) {
      return <NoPermission />
    }
  }

  return (
    <Box>
      <Box>
        <NestedTabsPage tabsList={storageNestedTabs} />
      </Box>
    </Box>
  )
}

export default StorageData
